(() => {
  const init = () => {
    const menu = document.getElementById('mobile-menu');
    const toggle = document.querySelector('.header__mobile-nav-toggle');
    const header = document.querySelector('.header');
    const host = header?.closest('.shopify-section');
    if (!menu || !toggle || !header || !host || menu.dataset.bwNavReady) return;
    menu.dataset.bwNavReady = 'true';
    host.classList.add('bw-mobile-nav-host');
    const spacer = document.createElement('div');
    spacer.className = 'bw-mobile-nav-spacer';
    spacer.hidden = true;
    spacer.setAttribute('aria-hidden', 'true');
    host.after(spacer);
    const media = matchMedia('(max-width:999px)');
    const panels = Array.from(menu.querySelectorAll('.mobile-menu__panel'));
    const background = new Map();
    const openLabel = toggle.getAttribute('aria-label');
    const labels = JSON.parse(document.getElementById('bw-audit-labels')?.textContent || '{}');
    let wasOpen = false;
    let savedScroll = 0;
    let frame = 0;
    const activePanel = () => panels.filter(el => el.classList.contains('is-open')).at(-1) || panels[0];
    const updateTop = () => {
      if (!wasOpen) return;
      const viewport = window.visualViewport?.height || window.innerHeight;
      const bottom = Math.max(0, Math.min(Math.round(header.getBoundingClientRect().bottom), Math.max(0, viewport - 120)));
      menu.style.setProperty('--bw-menu-top', bottom + 'px');
    };
    const scheduleTop = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(updateTop);
    };
    const isolateBackground = () => {
      document.querySelectorAll('main,.footer,#zipchat-shadow-host,[class*="kl-teaser-"]').forEach(el => {
        if (!background.has(el)) background.set(el, el.inert);
        el.inert = true;
      });
    };
    const sync = () => {
      const open = media.matches && menu.getAttribute('aria-hidden') === 'false';
      if (open && !wasOpen) {
        savedScroll = window.scrollY;
        spacer.style.height = host.offsetHeight + 'px';
        spacer.hidden = false;
      }
      document.body.classList.toggle('bw-mobile-nav-open', open);
      document.documentElement.classList.toggle('bw-mobile-nav-open', open);
      menu.inert = !open;
      const active = activePanel();
      panels.forEach(panel => { panel.inert = open && panel !== active; });
      toggle.setAttribute('aria-label', open ? (labels.closeMenu || openLabel) : openLabel);
      if (open) {
        isolateBackground();
      } else {
        background.forEach((inert, el) => { el.inert = inert; });
        background.clear();
        menu.querySelectorAll('[data-action="open-panel"]').forEach(el => el.setAttribute('aria-expanded','false'));
        spacer.hidden = true;
      }
      const entering = open && !wasOpen;
      const leaving = !open && wasOpen;
      wasOpen = open;
      if (open) { updateTop(); scheduleTop(); }
      if (entering) {
        panels[0].scrollTop = 0;
        requestAnimationFrame(() => active.querySelector('button,a')?.focus({preventScroll:true}));
      }
      if (leaving) {
        window.scrollTo({top:savedScroll,behavior:'instant'});
        if (media.matches) toggle.focus({preventScroll:true});
      }
    };
    new MutationObserver(sync).observe(menu,{attributes:true,attributeFilter:['aria-hidden','class'],subtree:true});
    new ResizeObserver(scheduleTop).observe(header);
    new MutationObserver(() => { if (wasOpen) isolateBackground(); }).observe(document.body,{childList:true,subtree:true});
    window.visualViewport?.addEventListener('resize',scheduleTop);
    media.addEventListener('change', () => {
      if (!media.matches && menu.getAttribute('aria-hidden') === 'false') toggle.click();
      sync();
    });
    menu.addEventListener('click',event => {
      const control=event.target.closest('[data-action="open-panel"],[data-action="close-panel"]');
      if (!control) return;
      requestAnimationFrame(() => {
        sync();
        if(control.dataset.action==='open-panel'){
          const panel=document.getElementById(control.getAttribute('aria-controls'));
          if(panel){panel.scrollTop=0;panel.querySelector('button,a')?.focus({preventScroll:true});}
        } else {
          const panel=control.closest('.mobile-menu__panel');
          menu.querySelector('[aria-controls="'+panel.id+'"]')?.focus({preventScroll:true});
        }
      });
    });
    document.addEventListener('keydown',event => {
      if(!wasOpen)return;
      if(event.key==='Escape'){
        event.preventDefault();
        const active=panels.filter(el=>el.classList.contains('is-open')).at(-1);
        if(active) active.querySelector('[data-action="close-panel"]')?.click();
        else toggle.click();
      }
      if(event.key==='Tab'){
        const items=Array.from(header.querySelectorAll('button,a,input,select,[tabindex="0"]')).filter(el=>!el.closest('[inert]')&&!el.disabled&&el.getClientRects().length&&getComputedStyle(el).visibility!=='hidden');
        const first=items[0],last=items.at(-1);
        if(event.shiftKey&&document.activeElement===first){event.preventDefault();last?.focus();}
        else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first?.focus();}
      }
    });
    sync();
  };
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
